import Breadcrumb from "../../components/Breadcrumb";
import ActividadesLayer from "../../components/classroom/ActividadesLayer";

const ActividadesPage = () => {
  return (
    <>
      <Breadcrumb title="Mis Actividades" />
      <ActividadesLayer />
    </>
  );
};

export default ActividadesPage;
